import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap'
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import GiftAnotherNumberModal from './gift-another-number-modal'
const BottomModalRedeemUsing = (props, { type }) => {
    const navigate = useNavigate()
    const { t } = useTranslation()

    return <>
        <Modal show={props.show} onHide={() =>props.toggleModal()} className='bottom_modal animated  slideInUp faster'>
            <Modal.Body>

                <div class="modal-body text-center">
                    <h3 class="primary_16 mb-3">{t("redeemusing")}</h3>
                    <div class="radiobutton-comp mt-3 pb-0 p-3 border-r16">
                        <div class="pay-cont" >
                            <div class="country-accro-comp p-0">
                            <div class="roaming-rates-col" onClick={() => props.name === "ViewAll" ? 
                                 navigate(`/ooredeorewards-home`, { state: props.data }) : navigate(`/ooredeorewards-viewall/${props.category}`, { state: props.data })}>
                                    <div class="d-flex align-items-center img-size01">
                                        <img src={process.env.PUBLIC_URL + '/assets/images/Tranfer%20credit.svg'} alt="" title="" />
                                        {t("use")} {props.data?.replace("965", "")}
                                    </div>
                                    <div class="right-arrow">
                                        <img src={process.env.PUBLIC_URL + '/assets/images/arrow_right_dark.svg'} alt="" title="" />
                                    </div>
                                </div>
                                <div class="roaming-rates-col" onClick={() => {
                                    props.toggle()
                                    props.toggleModal()
                                }}>
                                    <div class="d-flex align-items-center img-size01">
                                        <img src={process.env.PUBLIC_URL + '/assets/images/Nojoom_balance_transfer_icon.svg'} alt="" title="" />
                                        {t("gtan")}
                                    </div>

                                    <div class="right-arrow">
                                        <img src={process.env.PUBLIC_URL + '/assets/images/arrow_right_dark.svg'} alt="" title="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>

        </Modal>

    </>
}
export default BottomModalRedeemUsing;